import { AppState } from '../index';
import * as fromAttachments from './attachments.reducer';
import { createSelector } from '@ngrx/store';
import { Attachment, AttachmentsGroup } from 'src/app/model/attachments.model';
import { isEmpty } from '../../utils';
import AppError from '../../model/app-error';

export const selectAttachmentsState = createSelector(
  (state: AppState) => state.attachments,
  ({ state }: fromAttachments.State) => state,
);

export const selectAttachmentsGroupData = createSelector(
  (state: AppState) => state.attachments,
  ({ data }: fromAttachments.State): AttachmentsGroup[] | undefined => data?.result.groups,
);

export const selectAttachmentsError = createSelector(
  (state: AppState) => state.attachments,
  ({ error }: fromAttachments.State): AppError | null => error,
);

export const selectAttachmentsAllData = createSelector(
  (state: AppState) => state.attachments,
  ({ data }: fromAttachments.State): Attachment[] | undefined => data?.result.allAttachments,
);

export const selectAttachmentsIsAllDownloaded = createSelector(
  (state: AppState) => state.attachments,
  ({ data, downloadedFiles }: fromAttachments.State) => {
    const files: string[] = data?.result.groups.flatMap((group) => group.attachments.map(({ downloadLink }) => downloadLink)) || [];

    if (isEmpty(files) || isEmpty(downloadedFiles)) {
      return false;
    }

    return files.every((file) => downloadedFiles.includes(file));
  },
);
